import '../scss/style.scss';
import jQuery from 'jquery';
window.jQuery = jQuery;

require('./mukutu/jquery.coolify.js');
require('./mukutu/jquery.email-encrypt.js');
require('./mukutu/jquery.active-toggle.js');
require('./mukutu/jquery.function-runner.js');
require('./mukutu/jquery.form-focus.js');
require('./mukutu/jquery.smooth-scroll.js');
require('./mukutu/jquery.visible.js');
require('./mukutu/jquery.visible-add-class.js');
// require('./vendor/responsive-tables.js');
require('./vendor/password-hide-show.js');
require('./vendor/jquery.fluidbox.js');
require('flexslider');

!function ($) {
    var SubNavigationWrapperClassObserver = function() {
        var element = document.querySelector('.subNavigationWrapper');

        if (element) {
            if (element.classList.contains('_active')) {
                var ul = document.querySelector('nav.navigation > ul');
                ul.classList.add('_active');
            }
            var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

            var observer = new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (mutation.type == "attributes" && mutation.attributeName && mutation.attributeName === 'class') {
                        var ul = document.querySelector('nav.navigation > ul');

                        if (element.classList.contains('_active')) {
                            ul.classList.add('_active');
                        } else {
                            ul.classList.remove('_active');
                        }
                    }
                });
            });

            observer.observe(element, {
                attributes: true //configure it to listen to attribute changes
            });
        }
    };

    $(function () {
        $('section').visibleAddClass();
        SubNavigationWrapperClassObserver();

        $('[data-active-toggle]').activeToggle();
        //$('nav').navigationToggle();
        $('[data-function]').functionRunner();
        $('.flexslider').flexslider({
            animation: "fade",
            manualControls: "div.tabSelectWrapper ul li",
            slideshow: false,
            directionNav: false
        });
        //$('#content').coolify({ navigation: '.nav' });
        //$('.map').googleMapsPreventScrolling();
        //$('.hoverElement a').touchHover();

        // smooth scroll init
        $().smoothScroll();

        // fluid box init
        $('a[data-fluidbox]').fluidbox();

        // add classes by scroll position
        var position = $(window).scrollTop();
        $(window).scroll(function () {
            var navToggle = $('a.navigationToggle');
            var scrollTop = $('a.scrollToTop');

            if ($(document).scrollTop() > 350) {
                navToggle.addClass('_shrink');
                scrollTop.addClass('_shrink');
            } else {
                navToggle.removeClass('_shrink');
                scrollTop.removeClass('_shrink');
            }

            var scroll = $(window).scrollTop();
            if (scroll >= 350 && scroll > position) {
                navToggle.addClass('_hide');
                scrollTop.addClass('_hide');
            } else {
                navToggle.removeClass('_hide');
                scrollTop.removeClass('_hide');
            }
            position = scroll;
        });

    });
    $( document ).ready(function() {
        // $( ".infoStamp" ).each(function() {
        //     let element = 100;
        //     let width = $(this).width();
        //     $(this).css({'right': ((width / 10)) * -1 + "px"});
        // });

        $('a.navigationToggle').click(function() {
            if($('.navigationWrapper').hasClass('_active')) {
                $('.navigationWrapper,a.navigationToggle').removeClass('_active');
            } else {
                $('.navigationWrapper,a.navigationToggle').addClass('_active');
            }
        });
    });
}(jQuery);
